<template>
  <div>

    <v-form ref="inputForm" @submit.prevent="">

      <v-row>
        <v-col cols="12" md="6">
          <Combobox
            v-if="elsInUse.PaymentMethodID"
            v-model="paymentMethod" 
            :returnObject="true"
            :items="paymentMethodDS" 
            :label="elsLabel.PaymentMethodID"
            :helperText="elsHelperText.PaymentMethodID"
            @input="_paymentMethodChange"
            :rules="[elsRequired.PaymentMethodID ? rules.required : true]">
          </Combobox>
        </v-col>
      </v-row>

      <v-row v-if="sourceOfRepaymentsIsBP">
        <v-col cols="12" md="12">
          <div v-html="$let('SourceOfRepaymentsBPDisclaimer')"></div>
        </v-col>
      </v-row>

      <v-expand-transition v-if="enforceStandingOrder">
        <div>
          <v-row class="table--gray">
            <v-col cols="12" md="12">   
                <AccountDetails
                  v-model="model.soRepaymentAccount"
                  propertyModelName="SORepayment"
                  :rules="rules">
                </AccountDetails>
            </v-col>
          </v-row>
          
          <v-row>
            <v-col cols="12" md="6">
              <TextField 
                maxlength="50"
                v-model="model.soBranchName"
                v-if="elsInUse.SOBranchName"
                :label="elsLabel.SOBranchName"
                :helperText="elsHelperText.SOBranchName"
                :rules="[elsRequired.SOBranchName ? rules.required : true]">
              </TextField>
            </v-col>
            <v-col cols="12" md="6">
            </v-col>

            <v-col cols="12" md="12" class="pt-0">
              <PostalAddress
                v-model="model.soBranchAddress"
                propertyModelName="SOBranchAddress"
                :countryID="cuCountry"
                :rules="rules">
              </PostalAddress>          
            </v-col>

            <v-col cols="12" md="6">
              <Currency
                v-model="model.soAmount" 
                v-if="elsInUse.SOAmount"
                :disabled="true"
                :label="elsLabel.SOAmount"
                :helperText="elsHelperText.SOAmount"
                :rules="[rules.numeric, elsRequired.SOAmount ? rules.required : true]"
                :options="currencyOptions">
              </Currency>

              <DatePicker
                v-model="model.repaymentFirstDate"
                v-if="elsInUse.SOStartDate"
                :label="elsLabel.SOStartDate"
                :useIcon="true"
                :min="generic.todayString()"
                :helperText="elsHelperText.SOStartDate"
                :rules="[elsRequired.SOStartDate ? rules.required: true]">
              </DatePicker>
            </v-col>
            
            <v-col cols="12" md="6">
              <TextField
                v-model="model.soFrequency" 
                :disabled="true"
                :label="elsLabel.SOFrequency"
                :helperText="elsHelperText.SOFrequency"
                :rules="[elsRequired.SOFrequency ? rules.required : true]">
              </TextField>
            </v-col>

          </v-row>
        </div>
      </v-expand-transition>
    
      <v-expand-transition>
        <v-row v-if="enforcePayrollMandate">
          <v-col cols="12" md="6">
            <TextField
              v-model="model.pmFrequency" 
              :disabled="true"
              :label="elsLabel.PMFrequency"
              :helperText="elsHelperText.PMFrequency"
              :rules="[elsRequired.PMFrequency ? rules.required : true]">
            </TextField>

            <Currency
              v-model="model.pmAmount" 
              v-if="elsInUse.PMAmount"
              :disabled="true"
              :label="elsLabel.PMAmount"
              :helperText="elsHelperText.PMAmount"
              :rules="[rules.numeric, elsRequired.PMAmount ? rules.required : true]"
              :options="currencyOptions">
            </Currency>
          </v-col> 
          <v-col cols="12" md="6">
            <DatePicker
              v-model="model.repaymentFirstDate"
              v-if="elsInUse.PMStartDate"
              :label="elsLabel.PMStartDate"
              :useIcon="true"
              :min="generic.todayString()"
              :helperText="elsHelperText.PMStartDate"
              :rules="[elsRequired.PMStartDate ? rules.required : true]">
            </DatePicker>
          </v-col> 
        </v-row>
      </v-expand-transition>

      <StepperButtons
        @continueClick="_stepperContinue"
        @backClick="_stepperBack">
      </StepperButtons>
    
    </v-form>

  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import PostalAddress from './postal-address.vue'
  import StepperButtons from './stepper-buttons.vue';
  import AccountDetails from './account-details.vue';
  import TextField from '@/shared/components/text-field.vue';
  import Combobox from '@/shared/components/combobox.vue';
  import DatePicker from '@/shared/components/date-picker.vue';
  import Currency from '@/shared/components/currency.vue';
  import opmGeneric from '../utils/generic.js';
  import generic from '@/shared/utils/generic.js';
  import constants from '../constants/generic.js';

  export default {
    name: 'Repayments',
    components: {
      AccountDetails,
      Currency, 
      StepperButtons,
      PostalAddress,
      DatePicker,
      TextField, 
      Combobox
    },
    props: {
      rules: { type: Object },
    },    
    data() {
      return {
        generic,
        enforceStandingOrder: false,
        enforcePayrollMandate: false,
        paymentMethodDS: [],
        currencyOptions: opmGeneric.currencyConfig({ precision: 2 }),
        cuCountry: undefined,
        sourceOfRepaymentsIsBP: undefined,
        paymentMethod: undefined,
        model: {
          paymentMethodID: undefined,
          repaymentAccount: undefined,
          soBranchName: undefined,
          soBranchAddress: undefined,
          soAmount: window._inputs.inputModule.loanRepayment,
          soFrequency: undefined,
          pmFrequency: undefined,
          pmAmount: window._inputs.inputModule.loanRepayment,
          repaymentFirstDate: undefined,
        }
      };
    },
    async created() { 
      opmGeneric.setElementsConfig(this, this.elementsConfig); 
      // DropdownLists sources
      this.paymentMethodDS = this.referenceData ? this.referenceData.PaymentMethods : [];
      // FrequencyText
      const item = this.referenceData.Frequencies.find(el => el.ID == window._inputs.inputModule.loanFrequency);
      if (item) {
        this.model.soFrequency = item.Value;
        this.model.pmFrequency = item.Value;
      }
      this.cuCountry = this.$store.state.loanEnquiryConfig.CreditUnionInfo.Country;
    },
    methods: {
      _stepperBack() { 
        this.$emit("backClick"); 
      },
      _stepperContinue() {
        this.model.paymentMethodID = this.paymentMethod?.ID; // from Object to ID
        this.$emit("continueClick", this.model, this.$refs.inputForm); 
      },
      _paymentMethodChange($event) {
        this.enforceStandingOrder = $event.WebCode === constants.StandingOrder;
        this.enforcePayrollMandate = $event.WebCode == constants.PayrollMandate;
        this.sourceOfRepaymentsIsBP = $event.WebCode == constants.BenefitsToPayment;
      },
      // TODO: Validate Date of Payment - Must be between tomorrow and the dateReceived from PB
    },
    computed: {
      ...mapGetters(["referenceData", "elementsConfig"]),
    }
  };
</script>

<style lang="scss" scoped>

</style>